export default __webpack_public_path__ + "static/media/sbj-chemistry.8a429e05.svg";